import SiteLink from 'components/shared/sitelink';
import classNames from 'classnames';
import { useState, useEffect } from 'react';
import { addLocaleToHref } from 'lib/utils/helpers';
import { useRouter } from 'next/router';
import styles from './breadcrumbs.module.scss';

const Breadcrumbs = ({ className, locale, data }) => {
  const router = useRouter();
  const { breadcrumbs, breadcrumbEnd, style } = data;
  const [whiteStyle, setWhiteStyle] = useState(false);
  const [blackAndGreyStyle, setBlackAndGreyStyle] = useState(true);

  useEffect(() => {
    setWhiteStyle(style === 'White slashes and breadcrumb end');
    setBlackAndGreyStyle(style === 'Grey slashes and black breadcrumb end');
  }, [style]);

  return (
    <nav>
      <ol
        className={classNames(className, styles.breadcrumbsWrapper, {
          [styles.absolute]: whiteStyle,
        })}
      >
        {breadcrumbs?.map(breadcrumb => (
          <li key={breadcrumb.slug}>
            <SiteLink
              locale={locale}
              href={
                breadcrumb.externalLink
                  ? breadcrumb.externalLink
                  : addLocaleToHref(breadcrumb.slug, locale, router)
              }
              className={classNames(
                styles.breadcrumb,
                { [styles.white]: whiteStyle },
                { [styles.blackAndGrey]: blackAndGreyStyle }
              )}
            >
              {breadcrumb.title}
            </SiteLink>
            <span
              className={classNames(
                styles.breadcrumbSeparator,
                { [styles.blackAndGrey]: blackAndGreyStyle },
                { [styles.white]: whiteStyle }
              )}
            >
              /
            </span>
          </li>
        ))}
        <li>
          <p
            className={classNames(
              styles.breadcrumbEnd,
              { [styles.blackAndGrey]: blackAndGreyStyle },
              { [styles.white]: whiteStyle }
            )}
          >
            {breadcrumbEnd}
          </p>
        </li>
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
